module.exports = __webpack_public_path__ + "img/icon-status-wait.9a6a8cf4.svg";